import { render } from "./ExtraIMC.vue?vue&type=template&id=26145747"
import script from "./ExtraIMC.vue?vue&type=script&lang=js"
export * from "./ExtraIMC.vue?vue&type=script&lang=js"

import exportComponent from "/builds/lahautesociete/projects/roche/depistage-diabete/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__